
import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { CHART_COLORS } from '../exportUtils';

interface HealthChartProps {
  data: {
    totalItems: number;
    healthyItems: number;
    expiringSoonItems: number;
    expiredItems: number;
    [key: string]: any;
  };
}

const HealthChart: React.FC<HealthChartProps> = ({ data }) => {
  const { healthyItems, expiringSoonItems, expiredItems, totalItems } = data;
  
  if (totalItems === 0) return <p className="text-gray-500 italic">No data available</p>;
  
  const chartData = [
    { name: 'Healthy', value: healthyItems, color: CHART_COLORS.healthy },
    { name: 'Expiring Soon', value: expiringSoonItems, color: CHART_COLORS.expiringSoon },
    { name: 'Expired', value: expiredItems, color: CHART_COLORS.expired }
  ].filter(item => item.value > 0);
  
  return (
    <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
      <h3 className="text-sm font-medium mb-3">Inventory Health</h3>
      <div className="h-[180px]">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius={30}
              outerRadius={60}
              paddingAngle={2}
              dataKey="value"
              label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
              labelLine={false}
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip 
              formatter={(value: number) => [`${value} items`, 'Count']} 
              contentStyle={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: '4px' }}
            />
            <Legend layout="vertical" align="right" verticalAlign="middle" />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default HealthChart;
